import { tv } from 'tailwind-variants';

import { Flag, Icon, pluralize } from '@frontendmentorio/design-system-v2';

const styles = tv({
  base: 'rounded',
  variants: {
    severity: {
      error: 'bg-rose-600',
      info: 'bg-blue-500',
      warning: 'bg-orange-500',
    },
  },
});

export default function Header({ issue }) {
  return (
    <div className="flex flex-col gap-2 items-start justify-between w-full tablet:flex-row">
      <div className="flex flex-wrap gap-2 items-center">
        <Flag className={styles({ severity: issue.severity })}>
          {issue.severity}
        </Flag>

        {issue.category && (
          <h3 className="bg-neutral-200 font-secondary font-semibold leading-none px-2 py-1 rounded text-sm">
            {issue.category}
          </h3>
        )}

        {issue.isAI && (
          <span className="bg-violet-600 font-secondary font-semibold leading-none px-2 py-1 rounded text-sm text-white">
            AI Detected
          </span>
        )}

        {issue.occurrences && (
          <span className="font-secondary text-sm">
            {pluralize(issue.occurrences, 'occurrence')}
          </span>
        )}
      </div>

      {issue.link && (
        <a
          className="bg-blue-100 flex font-secondary gap-2 items-center px-2 py-1 rounded text-sm leading-none text-blue-500 hover:underline"
          href={issue.link}
          rel="noopener"
          target="_blank"
        >
          Read more <Icon name="arrow-up-right-from-square text-[0.8rem]" />
        </a>
      )}
    </div>
  );
}
